<template>
  <!-- Nothing to show when online and fully synced -->
  <div v-if="!isOnline || showPendingChip" class="d-flex align-center">
    <v-chip
      v-if="!isOnline"
      small
      color="secondary"
      text-color="white"
      class="me-2"
      :aria-label="$t('common.you_are_offline')"
    >
      <v-icon size="1.1rem" class="me-1">{{ icons.mdiCloudOffOutline }}</v-icon>
      {{ $t('common.offline_mode') }}
    </v-chip>

    <v-chip
      v-if="showPendingChip"
      small
      outlined
      color="warning"
      :aria-label="$t('common.pending_sync', { count: pendingSyncCount })"
    >
      <v-icon size="1.1rem" class="me-1">{{ icons.mdiCloudSyncOutline }}</v-icon>
      {{ $t('common.pending_sync', { count: pendingSyncCount }) }}
    </v-chip>
  </div>
</template>

<script>
import { mdiCloudOffOutline, mdiCloudSyncOutline } from '@mdi/js'

export default {
  name: 'ConnectivityChip',
  props: {
    // The general layout navbar sets this false: the "N pending to sync" counter
    // is noise there (it shows while online, on every view). The chip belongs to
    // the offline experience, so /offline leaves it on.
    showPending: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      icons: {
        mdiCloudOffOutline,
        mdiCloudSyncOutline,
      },
    }
  },
  computed: {
    isOnline() {
      return this.$store.getters['offline/isOnline']
    },
    pendingSyncCount() {
      return this.$store.getters['offline/pendingSyncCount']
    },
    showPendingChip() {
      return this.showPending && this.pendingSyncCount > 0
    },
  },
}
</script>
